import { render, staticRenderFns } from "./ResultList.vue?vue&type=template&id=c9bea85c&scoped=true&"
import script from "./ResultList.vue?vue&type=script&lang=js&"
export * from "./ResultList.vue?vue&type=script&lang=js&"
import style0 from "./ResultList.vue?vue&type=style&index=0&id=c9bea85c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9bea85c",
  null
  
)

export default component.exports